<ul class="zk-flex zk-flex-row zk-items-center zk-justify-around tab-panel-wrapper">
	<li 
		*ngFor="let tab of tabs" 
		class="zk-flex zk-flex-col zk-w-full zk-items-center"
		(keyup)="$event.key === 'Enter' ? activateTab() : null"
		(click)="activateTab(tab)" 
		[class.active]="tab.active"
	>
	  	<p freud-typography fontType="bodySemiboldAuto">
			{{ tab.name }}
		</p>
	</li>
</ul>
<ng-content></ng-content>